import { Outlet } from "@tanstack/react-router";

/**
 * Layout for the `/$lang` segment. Locale syncing is centralised in RootLayout
 * via `useLocale()` + `useSyncI18nLocale()`, so this component is a thin
 * pass-through whose only job is to provide a parent route for nested page
 * routes mounted under `/fr/...`.
 */
export function LocaleLayout() {
  return <Outlet />;
}
